import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";

const Forms = () => {
    const intl = useIntl();

    const LearnMoreLink = `https://www.atlassian.com${useLocalizedHref(
        "/software/jira/service-management/product-guide/tips-and-tricks/form-design-best-practices#why-form-design-matters"
    )}`;

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.Forms.header",
            defaultMessage: "Forms"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.Forms.body",
            defaultMessage:
                "Create dynamic, user-friendly forms so your teams can collect the data they need to provide outstanding customer service quickly and competently."
        }),
        body2: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.Forms.body2",
            defaultMessage:
                "The new low- to no-code form builder lets teams build and deploy forms that can be used on the portal and requests."
        }),
        link: intl.formatMessage(
            {
                id: "JiraServiceManagementPricingPage.features.Forms.learnMore",
                defaultMessage: "<learnMore>Learn more</learnMore> about forms."
            },
            {
                learnMore: (chunk: React.ReactNode) => (
                    <a
                        href={LearnMoreLink}
                        data-event="clicked"
                        data-event-component="linkButton"
                        data-product-key="jiraServiceManagement"
                        data-label-english="Learn more"
                    >
                        {chunk}
                    </a>
                )
            }
        )
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
            <p>{messages.body2}</p>
            <p>{messages.link}</p>
        </>
    );
};

export default Forms;
